import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { handleWhatsAppClick } from "../components/whatsappClickTrack";

function ThankyouPage() {
    const location = useLocation();

    useEffect(() => {
        window.gtag('config', 'AW-10999490476', {
            page_title: document.title,
            page_path: location.pathname,
        });

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'pageview',
            page: {
                url: location.pathname,
                title: document.title
            }
        });
    }, [location]);
    return (
        <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }} >
            <div className="p-4">
                <div className="d-flex justify-content-center">
                    <svg
                        height="100px"
                        width="100px"
                        version="1.1"
                        id="Capa_1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        viewBox="0 0 310.277 310.277"
                        xmlSpace="preserve"
                    >
                        <g>
                            <path
                                style={{ fill: "#25D366" }}
                                d="M155.139,0C69.598,0,0,69.598,0,155.139c0,85.547,69.598,155.139,155.139,155.139
		c85.547,0,155.139-69.592,155.139-155.139C310.277,69.598,240.686,0,155.139,0z M144.177,196.567L90.571,142.96l8.437-8.437
		l45.169,45.169l81.34-81.34l8.437,8.437L144.177,196.567z"
                            />
                        </g>
                    </svg>
                </div>
                <h3 className="text-center mt-4 pb-4">Thank You !</h3>
                <h6 className="text-center ptb-4">We've received your inquiry. Our team will review it and get back to you shortly.</h6>
                <h4 className="text-center ptb-2">OR</h4>
                <h6 className="text-center ptb-2">Want to chat with us?</h6>
                <div className='d-flex justify-content-center mt-4'>
                    <a href='https://wa.me/917796614664' rel='noopener noreferrer' target='_blank' onClick={handleWhatsAppClick}> <button className='ree-btn whatsapp-bg'><i className='fab fa-whatsapp'></i> WhatsApp Now</button></a>
                </div>
            </div>
        </div>
    );
}

export default ThankyouPage;
